function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["checked", "id", "input", "checkedBgColor", "style", "onChange", "uiTheme"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { getColor } from '../Theme/selectors';
import withTheme from '../Theme/withTheme';
var Radio = function Radio(_ref) {
  var checked = _ref.checked,
    id = _ref.id,
    input = _ref.input,
    checkedBgColor = _ref.checkedBgColor,
    customStyle = _ref.style,
    onChange = _ref.onChange,
    uiTheme = _ref.uiTheme,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var inputOptions = _objectSpread(_objectSpread({}, input), {}, {
    id: id
  });

  // Redux form stores all input info an input object,
  // to make sure we aren't conflicting with that we
  // make sure that we only add checked on onChange
  // if they are the expected type.
  if (typeof checked === 'boolean') {
    inputOptions.checked = checked;
  }
  if (typeof onChange === 'function') {
    inputOptions.onChange = onChange;
  }
  var style = {
    label: {
      display: 'inline-block',
      width: 16,
      minWidth: 16,
      height: 16,
      backgroundImage: 'url("https://d3itj9t5jzykfd.cloudfront.net/admin/circle.svg")',
      backgroundSize: inputOptions.checked ? 6 : 0,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: inputOptions.checked ? getColor(uiTheme, checkedBgColor) : '#FFF',
      border: inputOptions.checked ? 'none' : 'solid 1px #ECECEC',
      borderRadius: 8,
      boxSizing: 'border-box',
      boxShadow: 'rgba(6, 67, 95, 0.2) 0px 1px 1px, rgba(0, 0, 0, 0.1) 0px 2px 3px',
      transition: 'backgroundColor 400ms ease-out, background-size 200ms linear'
    },
    input: {
      visibility: 'hidden',
      position: 'relative'
    }
  };
  return /*#__PURE__*/React.createElement("label", {
    style: _objectSpread(_objectSpread({}, style.label), customStyle),
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "radio"
  }, inputOptions, otherProps, {
    style: style.input
  })));
};
Radio.defaultProps = {
  onChange: null,
  checked: undefined,
  input: undefined,
  checkedBgColor: '#00A0D1',
  style: {},
  uiTheme: null
};
export default withTheme(Radio);